import VoucherTemplates from '../../../../store/vouchers/templates';

angular
    .module('festzelt-os.vouchers.templates')
    .factory('VoucherTemplates', [
        '$injector',
        'VoucherTemplate',
        ($injector, VoucherTemplate) => new VoucherTemplates(VoucherTemplate, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/templates/store/voucher-templates.js